/**
 * Auth DTOs mirroring the backend `/api/auth` contract. These will be replaced by
 * the generated `@nabotavle/data-access` client once a real OpenAPI generator is
 * wired (0.4 contract step); kept local for now.
 */

/** One tenant the user belongs to (the login tenant-chooser + /me). */
export interface TenantMembership {
  tenantId: string;
  tenantName: string;
  role: string;
}

/** Result of login / tenant-switch / step-up. */
export interface LoginResult {
  accessToken: string;
  expiresAtUtc: string;
  activeTenantId: string | null;
  role: string | null;
  memberships: TenantMembership[];
}

/** The current principal (GET /api/auth/me). */
export interface MeResult {
  userId: string;
  email: string;
  name: string;
  phone: string | null;
  /** False for Vipps-only accounts — the account form then asks for no current password. */
  hasPassword: boolean;
  activeTenantId: string | null;
  memberships: TenantMembership[];
}

/** Body of PUT /api/auth/me — the caller's own account. */
export interface UpdateMeRequest {
  name: string;
  phone: string | null;
  email: string;
  /** Required by the API when the email changes on a password account. */
  currentPassword?: string;
}

/** Built-in roles (mirror of the backend MembershipRole names). */
export type Role =
  | 'BeboerEier'
  | 'Leietaker'
  | 'Medboer'
  | 'Styremedlem'
  | 'Styreleder'
  | 'Vaktmester'
  | 'Forvalter';

/**
 * True when holding <c>held</c> satisfies a requirement for <c>required</c>.
 * Mirrors the backend hierarchy: styreleder ⊃ styremedlem; otherwise exact match.
 */
export function roleSatisfies(held: string | null | undefined, required: Role): boolean {
  if (!held) {
    return false;
  }
  if (held === required) {
    return true;
  }
  return held === 'Styreleder' && required === 'Styremedlem';
}

/** What an invitation link shows before login (`GET /api/onboarding/invitation?token=`). */
export interface InvitationPreview {
  tenantId: string;
  tenantName: string;
  /** Null for an SMS invitation — the invitee then types their address. */
  email: string | null;
  state: 'open' | 'expired' | 'used';
  /** True ⇒ the address already has an account: log in and accept, instead of creating one. */
  hasAccount: boolean;
}
